import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class NotificacaoService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
    this.url = configService.getURL() + 'notificacao';
    this.token = new Login();
   }

   all(page = 1){
    return this.http.get<Object[]>(this.url + '?page=' + page, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  lido(idnotificacao){
    return this.http.post<Object[]>(this.url + '/lido', idnotificacao , {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
